module.exports = __webpack_public_path__ + "img/arrow-left.72959702.svg";